import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Bill } from 'src/app/model/bill.model';
import { Customer } from 'src/app/model/customer.model';
import { Employee } from 'src/app/model/employee.model';
import { ApiService } from 'src/app/services/api.service';
import { EmployeeDialog } from '../employee/employee.component';

@Component({
  selector: 'app-duebills',
  templateUrl: './duebills.component.html',
  styleUrls: ['./duebills.component.scss']
})
export class DuebillsComponent implements OnInit {
// private apiService: ApiService
displayedColumns: string[] = ['customerId', 'customerName', 'customerPhone', 'customerAddress', 'customerUnitRate', 'customerDueAmount', 'bill'];
dataSource = new MatTableDataSource<Customer>(null);
customer: Customer = {
  areaCode: null,
  areaName: null,
  meterId: 0,
  previousReading:0 ,
  currentReading:0 ,
  latitude: null,
  longitude: null,
  customerId: 0,
  customerName: '',
  customerPhone: null,
  customerPhone2: null,
  customerPhone3: null,
  customerEmail: '',
  customerAddress: '',
  customerStatus: '',
  customerJoinedDate: '',
  customerUnitRate: 0,
  defaultUnitRate: 0,
  customerDueAmount: 0,
  customerAction: 'add'
}
selectedCustomer: Customer;
billData: Bill[];
dtOptions: any = {};
showPrintTable: boolean = false;

@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

constructor(public dialogRef: MatDialogRef<EmployeeDialog>,
  @Inject(MAT_DIALOG_DATA) public data: Employee,
  private apiService: ApiService,
  private _snackBar: MatSnackBar) {
  this.getCustomerData();
  this.showPrintTable = false;

}
customers: Customer[] = [];
seletedCustomer: Customer;

startDate: string;
endDate: string;

ngOnInit(): void {
  this.dtOptions = {
    pagingType: 'full_numbers',
    pageLength: 3,
    processing: true,
    dom: 'Bfrtip',
      buttons: [
          'copy', 'csv', 'excel', 'print'
      ]
  };
}
applyFilter(filterValue: string) {
  this.dataSource.filter = filterValue.trim().toLowerCase();
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }
}



computeRh(): void {
  let previousRh = 0; // Initialize the RH for the first bill

  this.billData.forEach((bill, index) => {
    const currentRh = bill.dueAmount - bill.badDebt - bill.discount;

    if (index === 0) {
      bill.rh = currentRh; // First row: only calculate current RH
    } else {
      bill.rh = previousRh + currentRh; // Subsequent rows: add current RH to previous RH
    }

    previousRh = bill.rh; // Update the previous RH for the next iteration
  });

  let rhore =0;

  this.billData.forEach((bill, index) => {

  if(index == 0){
    rhore = 0;
  }else{
    let bill : Bill = this.billData[index-1];
    rhore =bill.rh;
  }

  bill.wadarta = bill.billAmount + rhore;
  bill.finalBillDueAmount = (bill.wadarta - (bill.billAmount - bill.dueAmount)) - bill.badDebt - bill.discount;

   });
}


openbillDialog(customer: Customer){
  this.selectedCustomer = customer;
  this.apiService.getCustomersDueBills(customer)
  .subscribe(data => {
      this.billData = data.bills;
      this.applyBillDateFilter();
      this.computeRh();
      this.billData = this.billData.map((bill,index)=>{
        let pa = bill.billAmount - bill.dueAmount;
        let rh=0;
        if(index == 0){
          rh = 0;
        }else{
          let billTemp : Bill = this.billData[index-1];
          rh = billTemp.rh;
        }
        let wadarta = bill.billAmount + rh;
        return {
          ...bill,
          pa,
          rh,
          wadarta
        }
      })
      this.showPrintTable = !this.showPrintTable
    });
}


applyBillDateFilter() {
  if (!this.startDate || !this.endDate) {
    return this.billData; // If either date is missing, don't filter
  }

  const start = new Date(this.startDate);
  const end = new Date(this.endDate);

  this.billData = this.billData.filter(bill => {
    const billDate = new Date(bill.billDate);
    return billDate >= start && billDate <= end;
  });
}



applyDateFilter() {
  if (this.startDate && this.endDate) {
    console.log(`Bills are fetched between ${this.startDate} and ${this.endDate}. You can view them.`);

    this._snackBar.open(
      `Bills fetched between ${this.startDate} and ${this.endDate}`,
      'Close',
      { duration: 3000 }
    );
  }
}



printDueBills(){

  let popupWinindow;
  let innerContents = document.getElementById("printDueBills").innerHTML;
  console.log(innerContents);
  popupWinindow = window.open('', '_blank', 'scrollbars=yes,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  popupWinindow.document.open();
  popupWinindow.document.write('<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous"><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()"><div ="customerDueBills">' + innerContents + '</div></html>');
  popupWinindow.document.close();

  
}

getCustomerData() {

  this.apiService.getCustomersWithDues(this.data)
    .subscribe(data => {
      this.dataSource.data = data.customers;
      const newCustomerId =  Math.max.apply(Math, data.customers.map(function(o : Customer) { return o.customerId; }));
      this.customer.customerId = newCustomerId + 1;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
  
           // filter logic
      this.dataSource.filterPredicate = (data: Customer, filter: string) =>
        data.customerId.toString().includes(filter) ||
        data.customerName.trim().toLowerCase().includes(filter) ||
        (data.customerPhone ? data.customerPhone.toString().includes(filter) : false);
    });
}

}
